import { mergeTerm } from './mergeTerm';
import { mergeTerms } from './mergeTerms';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { EJsonQueryType } from '../../types/jsonQuery/term';

const CHIPS_FIELDS: Array<keyof IJsonQuery> = ['isFromBank', 'isFromBuilder', 'searchType'];

/**
 * Утилита для мерджа двух jsonQuery
 * - для полей типа Term
 *   - для полей чипсов применяется новое значение, если оно непустое
 *   - для полей нечипсов применяется новое значение всегда
 * - для полей типа Terms - новые значения массива добавятся после основных
 *
 * @export
 * @param {IJsonQuery} jsonQuery - Основной объект jsonQuery
 * @param {IJsonQuery} newJsonQuery - новый jsonQuery, его значения будут добавляться в основной
 * @returns {IJsonQuery}
 */
export const mergeJsonQuery = (jsonQuery: IJsonQuery, newJsonQuery: IJsonQuery) => {
  const jsonQueryMap = new Map(Object.entries(jsonQuery));
  const newJsonQueryMap = new Map(Object.entries(newJsonQuery));

  if (newJsonQueryMap.size === 0) {
    return newJsonQuery;
  }

  for (const entry of newJsonQueryMap) {
    const [newJsonQueryKey, newJsonQueryFilter] = entry;
    const jsonQueryFilter = jsonQueryMap.get(newJsonQueryKey);
    const jsonQueryType = newJsonQueryFilter?.type || jsonQueryFilter?.type;

    if (jsonQueryType === EJsonQueryType.Term) {
      const applyNewValue = newJsonQueryFilter || !CHIPS_FIELDS.includes(newJsonQueryKey as keyof IJsonQuery);

      if (applyNewValue) {
        const newTerm = mergeTerm({ jsonQueryPart: jsonQueryFilter, newJsonQueryPart: newJsonQueryFilter });
        jsonQueryMap.set(newJsonQueryKey, newTerm);
      }
    }

    if (jsonQueryType === EJsonQueryType.Terms) {
      const newTerms = mergeTerms({ jsonQueryPart: jsonQueryFilter, newJsonQueryPart: newJsonQueryFilter });
      jsonQueryMap.set(newJsonQueryKey, newTerms);
    }
  }

  return Object.fromEntries(jsonQueryMap);
};
